module.exports = __webpack_public_path__ + "static/media/visit3.08dbe3dc.png";